// 고객 문의 실시간 수신(2026-07-22) — 실서비스 채팅 WS 에 익명 접속해서
// support_ticket_event(접수/추가답장) 푸시만 받는다. 데이터 조회는 기존 인증
// REST(/analytics/cx/tickets) 그대로 — 이 소켓은 "새 문의 왔다" 신호 전용.
// 수신 시 window "novadb:cx-event" CustomEvent 로 전파(탭 배지 + CxSection 갱신).

const WS_URL = "wss://nova-ws.sedaily.ai";
const PING_MS = 5 * 60 * 1000; // API GW 유휴 타임아웃(10분) 대비 keepalive
const RECONNECT_BASE_MS = 5_000;
const RECONNECT_MAX_MS = 60_000;

let ws = null;
let pingTimer = null;
let reconnectTimer = null;
let reconnectDelay = RECONNECT_BASE_MS;
let closedByUser = false;

function cleanup() {
  if (pingTimer) { clearInterval(pingTimer); pingTimer = null; }
  if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
}

function open() {
  if (closedByUser) return;
  try {
    ws = new WebSocket(WS_URL);
  } catch {
    scheduleReconnect();
    return;
  }

  ws.onopen = () => {
    reconnectDelay = RECONNECT_BASE_MS;
    pingTimer = setInterval(() => {
      try { ws?.send(JSON.stringify({ action: "ping" })); } catch { /* onclose 가 처리 */ }
    }, PING_MS);
  };

  ws.onmessage = (e) => {
    try {
      const data = JSON.parse(e.data);
      if (data.type === "support_ticket_event") {
        window.dispatchEvent(new CustomEvent("novadb:cx-event", { detail: data }));
      }
    } catch { /* pong 등 무시 */ }
  };

  ws.onclose = () => {
    cleanup();
    ws = null;
    scheduleReconnect();
  };

  ws.onerror = () => {
    try { ws?.close(); } catch { /* 이미 닫힘 */ }
  };
}

function scheduleReconnect() {
  if (closedByUser || reconnectTimer) return;
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null;
    open();
  }, reconnectDelay);
  reconnectDelay = Math.min(reconnectDelay * 2, RECONNECT_MAX_MS);
}

export function connectSupportWs() {
  closedByUser = false;
  if (!ws) open();
}

export function disconnectSupportWs() {
  closedByUser = true;
  cleanup();
  try { ws?.close(); } catch { /* 이미 닫힘 */ }
  ws = null;
}
